import { FC, Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { Trans } from "react-i18next";
import { getCurrentUser, logout } from "../services/authService";
import TriangleIcon from "../icons/triangle";
import UserIcon from "../icons/user";

type ProfileManagementProps = {
  theme?: "dark" | "light";
};

const ProfileManagement: FC<ProfileManagementProps> = ({ theme = "dark" }) => {
  const user = getCurrentUser();

  const Logout = async () => {
    logout();
    window.location.reload();
  };

  return (
    <div className="flex gap-[10px] lg:gap-3 items-center">
      <div
        className={`grid items-center justify-items-end ${
          theme === "light" ? "text-[#1E408E]" : "text-white"
        }`}
      >
        <span className="text-sm lg:text-xl first-letter:uppercase">
          {user}
        </span>
        <i className="text-sm text-end">
          {" "}
          <Trans i18nKey="is logged in">is logged in</Trans>
        </i>
      </div>

      <Menu as="div" className="relative">
        <Menu.Button className="flex items-center gap-[5px] lg:gap-[10px] bg-primary text-white lg:font-semibold font-bold">
          <span
            className={`flex justify-center items-center p-2 h-[38px] md:h-[52px] w-[38px] md:w-[52px] rounded-full ${
              theme === "light" ? "bg-[#1E408E]" : "bg-white"
            }`}
          >
            <UserIcon
              className={`w-[32px] ${
                theme === "light" ? "text-white" : "text-[#1E408E]"
              }`}
            />
          </span>
          <div className="hidden md:flex items-center text-[#D9D9D9] relative">
            <TriangleIcon />
          </div>
        </Menu.Button>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="origin-top-right absolute right-0 mt-2 p-3 pr-10 min-w-[14rem] w-fit rounded-md bg-gray-300">
            <div>
              <Menu.Button
                className="cursor-pointer hover:underline p-1 rounded"
                onClick={Logout}
              >
                <Trans i18nKey="Logout">Logout</Trans>
              </Menu.Button>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};
export default ProfileManagement;
